import { formatCurrency } from '@utils/formatters';

const ChartTooltip = ({ active, payload, label, formatter }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-gray-800 p-3 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700 text-sm">
      {label && <p className="font-semibold text-gray-700 dark:text-gray-300 mb-1">{label}</p>}
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ background: p.color || p.stroke }} />
          <span className="text-gray-500">{p.name}:</span>
          <span className="font-medium text-gray-900 dark:text-white">
            {formatter ? formatter(p.value) : formatCurrency(p.value)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ChartTooltip;
